import { Analytics } from "./types";

type HubSpotIdentifyParams = {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

type HubSpotTrackParams = {
  name: string;
  properties?: Record<string, any>;
};

type HubSpotQueueItem =
  | ["trackPageView"]
  | ["setPath", string]
  | ["identify", HubSpotIdentifyParams]
  | ["trackCustomBehavioralEvent", HubSpotTrackParams];

type HubSpotQueue = Array<HubSpotQueueItem>;

declare global {
  interface Window {
    _hsq: HubSpotQueue;
  }
}

export class HubspotSourceProvider {
  private hsq: HubSpotQueue = [];

  initialize() {
    window._hsq = window._hsq || [];
    this.hsq = window._hsq;

    return HubspotAnalytics(this.hsq);
  }
}

export interface HubspotClient {
  provider: "hubspot";
}

export function makeHubspotClient(): HubspotClient {
  return {
    provider: "hubspot",
  };
}

function HubspotAnalytics(_hsq: HubSpotQueue): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: (userID, traits) => {
      _hsq.push([
        "identify",
        {
          ...(userID && { id: userID }),
          ...(traits?.firstName && { firstName: traits?.firstName }),
          ...(traits?.lastName && { lastName: traits?.lastName }),
          ...(traits?.email && { email: traits?.email }),
        },
      ]);
      _hsq.push(["trackPageView"]);
    },
    screen: () => {
      _hsq.push(["setPath", window.location.pathname + window.location.search]);
      _hsq.push(["trackPageView"]);
    },
    ecommerceEvent: (eventName) => {
      if (_hsq) {
        // TODO: implement ecommerce tracking for hubspot
      }
    },
    event: (eventName, props) => {
      _hsq.push([
        "trackCustomBehavioralEvent",
        {
          name: eventName,
          properties: props,
        },
      ]);
    },
  };
}
